// extracted by mini-css-extract-plugin
export default {"container":"S06_container__83G5u","limiter":"S06_limiter__ndVeS","sub":"S06_sub__p1Fbo","title":"S06_title__LD+Ip","text":"S06_text__Pi4RR","linkBtn":"S06_linkBtn__h1tIK"};